/**
 * Internal dependencies
 */
import ConfirmDialog from './component';

export { ConfirmDialog };
